module.exports = __webpack_public_path__ + "media/images/countrysquared/ni-a450f47513c1863f7b0e8a597fe95979.svg";